/* global appData */

import VueRouter from 'vue-router';

import { formatWordpressRoutes } from './utils/format-wordpress-routes';
import { NotFound } from './components/404';
import { LogIn } from './components/login/login'
import * as postTypeComponents from './components/post-types/';

const routes = [
	{
		path: '/log-in',
		component: LogIn,
	},
	{
		path: '*',
		component: NotFound,
	},
];

export const router = new VueRouter({
	mode: 'history',
	routes: routes,
});
const wordpressRoutes = formatWordpressRoutes(appData.routes, postTypeComponents);
router.addRoutes(wordpressRoutes);



// WEBPACK FOOTER //
// ./assets/_js/router.js